/** Garde-fou : n’applique une réponse que si elle correspond encore à la division affichée. */
export function shouldApplyStandingsResult(
  requestedDivision: number,
  selectedDivision: number
): boolean {
  return requestedDivision === selectedDivision;
}

/** Un fetch en cours pour la même division doit être réutilisé, pas relancé. */
export function shouldStartStandingsFetch(
  divisionId: number,
  inFlightDivision: number | null
): boolean {
  return inFlightDivision !== divisionId;
}
